<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-14 23:08:52
 * @LastEditTime: 2025-09-05 01:23:11
-->
<template>
  <div class="login">
    <h1>登录</h1>

    <van-form @submit="onSubmit" class="form-block">
      <van-field v-model="username" name="phone" placeholder="请输入手机号" class="form-item" />
      <van-field v-model="password" type="password" name="password" placeholder="请输入密码" class="form-item" />
      <div style="margin: 16px 0px;">
        <van-button round block type="danger" native-type="submit" :loading="loading">登录</van-button>
        <!-- <van-button round block type="info" native-type="submit" :loading="loading"></van-button> -->
        <div class="text" @click="ontextpage">忘记密码</div>

      </div>
    </van-form>

    <van-dialog v-model="show" title="公告出岗情况" @confirm="handleConfirm">
      <div style="height: 280px;overflow: auto;padding: 10px;">
        <van-list
          v-model="loading1"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
          <li v-for="i,index in countList" :key="index" :class="['infinite-list-item', i.isBold ? 'fontWeight' : '']" style="display:flex;margin: 10px 0px;align-items:center;flex-wrap: wrap;margin:10px 0px;height: 24px;">
              {{i.companyName}} 近<p style="color: red;">7天</p>更新<p style="color: red;">{{i.count}}个</p>岗位
          </li>
        </van-list>
      </div>
    </van-dialog>

    <van-dialog v-model="show1" title="投递信息复盘" @confirm="handleConfirm1">
      <div style="padding: 20px;">
        <b>同学你好，您的投递情况情况如下:</b>
        <li style="display:flex;margin: 10px 0px;align-items:center;">
            近<p style="color: red;">7天</p>更新的岗位数量 <p style="color:red;">{{currentModal2.importCount}}个</p>
        </li>
        <li style="display:flex;margin: 10px 0px;align-items:center;">
            近<p style="color: red;">7天</p>符合报考的数量 <p style="color:red;">{{currentModal2.postCount}}个</p>
        </li>
        <li style="display:flex;margin: 10px 0px;align-items:center;">
            近<p style="color: red;">7天</p>您的投递的数量 <p style="color:red;">{{currentModal2.sendCount}}个</p>
        </li>
        <p>
            求职是一场““持久战”，与其纠结“这个岗位该不该投”，不如先投出去 - 即使没通过，也是为下一次成功积累经验;而如果因为犹豫错过，可能就少了一个改变的机会。
        </p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { login, recentCompanyPostsCounts, recentCompanyPostsStatistics } from "@/api/xicaiquan";
import tools from "@/libs/utils";
import Vue from "vue"
import { Dialog, List } from 'vant'
Vue.use(Dialog)
Vue.use(List)
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      current: 1,
      size: 10,
      show: false,
      show1: false,
      list: [],
      loading1: false,
      finished: false,
      resFlag: false,
      currentModal2: {},
      countList: [],
      modal1Total: 0
      
    };
  },
  created() {},
  components: {},
  watch: {},
  methods: {
    async login(data) {
      this.loading = true;
      const res = await login(data);
      this.loading = false;
      console.log(res);
      if (res.code == 200) {
        tools.setToken1(res.data.tokenValue);

        const result = await Promise.all([
          this.handleModal1(true),
          this.handleModal2()
        ]);

        console.log("result", result)

        if (!result[0].data.records.length && result[1].data.importCount == 0 && result[1].data.postCount == 0 && result[1].data.sendCount == 0) {
          this.$router.replace({ path: '/tool' });
        }

        // this.handleModal1(true)
        // this.handleModal2()
        // this.$router.push('/tool')
        // this.$router.replace({ path: '/tool' });

      }
    },
    ontextpage(){
        this.$router.push({
          path:'/resetPassword'
        })
    },
    onSubmit(values) {
      this.login(values);
      console.log("submit", values);
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      if (this.countList.length >= this.modal1Total) {
          return;
      }
      this.handleModal1()

      
    },
    async handleModal1(flag) {
        this.loading1 = true; 
        const res = await recentCompanyPostsCounts({current: this.current, size: this.size})
        if (res.code == 200) {
          this.loading1 = false;
          this.modal1Total = res.data.total;
          if (res.data.records.length) {
            this.countList.push(...res.data.records);

            if (flag) {
                this.show = true;
            }

            if (this.countList.length >= this.modal1Total) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            // this.finished = res.data.records.length < 10;

            this.current ++
          } else {
            this.loading1 = false;



            if (this.countList.length >= this.modal1Total) {
              this.finished = true;
            } else {
              this.finished = false;
            }


            if (flag) {
                this.show = false;
            }
          }

        } else {
          this.loading1 = false;
        }
        

        console.log("loading1", this.loading1)
        return res;
    },
    async handleModal2() {
        const res = await recentCompanyPostsStatistics()
        if (res.data.importCount == 0 && res.data.postCount == 0 && res.data.sendCount == 0) {
          this.show1 = false;
        } else {
          this.show1 = true
        }
        this.currentModal2 = res.data;
        console.log(res)
        return res;
    },
    handleConfirm1() {
      if (!this.show) {
        this.$router.replace({ path: '/tool' });
      }
      // console.log(this.show, this.show1)
      // console.log("eeeeee")
    },
    handleConfirm() {
      if (!this.show1) {
        this.$router.replace({ path: '/tool' });
      }
    }
  },
};
</script>
<style scoped lang="scss">
h1 {
  text-align: center;
  margin: 30px auto;
}

.login {
  height: 100vh;
  background: #fff;
  overflow: hidden;
}

.form-block {
  width: 90%;
  margin: 0px auto;

  /deep/ .form-item {
    margin: 20px 0px;
    background: #e8eef1;
    border-radius: 10px;
  }
}
.text{
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-weight: bold;
  color: #1989fa;
}
</style>
